import { render } from "./NouveauMedecin.vue?vue&type=template&id=fde6b35a"
import script from "./NouveauMedecin.vue?vue&type=script&lang=js"
export * from "./NouveauMedecin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__